export default __webpack_public_path__ + "static/media/Abeerlogo.30e4ec88.png";